export const campuses = [
  {
    id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
    externalId: 3,
    name: 'Campus Antwerpen',
    address: 'Harmoniestraat 68, 2018 Antwerpen',
    email: 'acom@azmonica.be',
    isHigherFees: false,
    isAvailableQR: true
  },
  {
    id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
    externalId: 9,
    name: 'Private Campus Kielse Vest',
    address: 'Kielsevest 14, 2018 Antwerpen',
    email: 'kielsevest@azmonica.be',
    isHigherFees: true,
    isAvailableQR: true
  },
  {
    id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
    externalId: 5,
    name: 'Campus Deurne',
    address: 'Stevenslei 20, 2100 Deurne',
    email: 'ortho-spm@azmonica.be',
    isHigherFees: false,
    isAvailableQR: true
  }
];

export const practitioners = [
  {
    id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
    photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
    externalIds: ['272'],
    email: 'peter.verdonk@azmonica.be',
    phone: '+320455555555',
    title: 'Prof. Dr.',
    firstName: 'Peter',
    lastName: 'Verdonk',
    paymentService: 'SL-4882-5171',
    localizations: [
      {
        lang: 'en',
        name: 'Prof. Dr. Peter Verdonk',
        specialties: 'Knee and sports injuries'
      },
      {
        lang: 'nl',
        name: 'Prof. Dr. Peter Verdonk',
        specialties: 'Knie en sportletsels'
      }
    ]
  },
  {
    id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
    photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
    externalIds: ['152', '159'],
    email: 'roger.vanriet@azmonica.be',
    phone: '+320455555555',
    title: 'Dr.',
    firstName: 'Roger',
    lastName: 'Van Riet',
    paymentService: 'SL-1626-8131',
    localizations: [
      {
        lang: 'en',
        name: 'Prof. Dr. Roger Van Riet',
        specialties: 'Elbow, wrist and hand'
      },
      {
        lang: 'nl',
        name: 'Prof. Dr. Roger Van Riet',
        specialties: 'Elleboog, pols en hand'
      }
    ]
  }
];

export const freeSlots = [
  {
    id: '5101324',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2019-03-19T13:40:00',
    endTime: '2019-03-19T13:50:00'
  },
  {
    id: '5101325',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2019-03-19T13:50:00',
    endTime: '2019-03-19T14:00:00'
  },
  {
    id: '5104686',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2019-03-19T14:00:00',
    endTime: '2019-03-19T14:10:00'
  },
  {
    id: '5104687',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2019-03-19T14:10:00',
    endTime: '2019-03-19T14:20:00'
  },
  {
    id: '5104688',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2019-03-19T14:20:00',
    endTime: '2019-03-19T14:30:00'
  },
  {
    id: '5104689',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2019-03-19T14:30:00',
    endTime: '2019-03-19T14:40:00'
  },
  {
    id: '5104690',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2019-03-19T14:40:00',
    endTime: '2019-03-19T14:50:00'
  },
  {
    id: '5104691',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2019-03-19T14:50:00',
    endTime: '2019-03-19T15:00:00'
  },
  {
    id: '5104692',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2019-03-19T15:00:00',
    endTime: '2019-03-19T15:10:00'
  },
  {
    id: '5104693',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2019-03-19T15:10:00',
    endTime: '2019-03-19T15:20:00'
  },
  {
    id: '5104694',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2019-03-19T15:20:00',
    endTime: '2019-03-19T15:30:00'
  },
  {
    id: '5104695',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2019-03-19T15:30:00',
    endTime: '2019-03-19T15:40:00'
  },
  {
    id: '5101327',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2019-03-19T14:00:00',
    endTime: '2019-03-19T14:10:00'
  }
];

export const bigFreeSlots = [
  {
    id: '5101361',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-22T14:30:00',
    endTime: '2018-12-22T14:40:00'
  },
  {
    id: '5101364',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-22T15:00:00',
    endTime: '2018-12-22T15:10:00'
  },
  {
    id: '5101366',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-22T15:10:00',
    endTime: '2018-12-22T15:20:00'
  },
  {
    id: '5101367',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-22T15:20:00',
    endTime: '2018-12-22T15:30:00'
  },
  {
    id: '5104704',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-24T08:40:00',
    endTime: '2018-12-24T08:50:00'
  },
  {
    id: '5104705',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-24T08:50:00',
    endTime: '2018-12-24T09:00:00'
  },
  {
    id: '5104706',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-24T09:00:00',
    endTime: '2018-12-24T09:10:00'
  },
  {
    id: '5104707',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-24T09:10:00',
    endTime: '2018-12-24T09:20:00'
  },
  {
    id: '5104708',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-24T09:20:00',
    endTime: '2018-12-24T09:30:00'
  },
  {
    id: '5104709',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-24T09:30:00',
    endTime: '2018-12-24T09:40:00'
  },
  {
    id: '5104710',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-24T09:40:00',
    endTime: '2018-12-24T09:50:00'
  },
  {
    id: '5104711',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-24T09:50:00',
    endTime: '2018-12-24T10:00:00'
  },
  {
    id: '5104712',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-24T10:00:00',
    endTime: '2018-12-24T10:10:00'
  },
  {
    id: '5104714',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-24T10:20:00',
    endTime: '2018-12-24T10:30:00'
  },
  {
    id: '5104723',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-24T13:00:00',
    endTime: '2018-12-24T13:10:00'
  },
  {
    id: '5104724',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-24T13:10:00',
    endTime: '2018-12-24T13:20:00'
  },
  {
    id: '5104725',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-24T13:20:00',
    endTime: '2018-12-24T13:30:00'
  },
  {
    id: '5104726',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-24T13:30:00',
    endTime: '2018-12-24T13:40:00'
  },
  {
    id: '5104727',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-24T13:40:00',
    endTime: '2018-12-24T13:50:00'
  },
  {
    id: '5104728',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-24T13:50:00',
    endTime: '2018-12-24T14:00:00'
  },
  {
    id: '5104729',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-24T14:00:00',
    endTime: '2018-12-24T14:10:00'
  },
  {
    id: '5104730',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-24T14:10:00',
    endTime: '2018-12-24T14:20:00'
  },
  {
    id: '5104731',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-24T14:20:00',
    endTime: '2018-12-24T14:30:00'
  },
  {
    id: '5104732',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-24T14:30:00',
    endTime: '2018-12-24T14:40:00'
  },
  {
    id: '5104733',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-24T14:40:00',
    endTime: '2018-12-24T14:50:00'
  },
  {
    id: '5101370',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-22T15:30:00',
    endTime: '2018-12-22T15:40:00'
  },
  {
    id: '5101371',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-22T15:40:00',
    endTime: '2018-12-22T15:50:00'
  },
  {
    id: '5101372',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-22T15:50:00',
    endTime: '2018-12-22T16:00:00'
  },
  {
    id: '5101374',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-22T16:00:00',
    endTime: '2018-12-22T16:10:00'
  },
  {
    id: '5101375',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-22T16:10:00',
    endTime: '2018-12-22T16:20:00'
  },
  {
    id: '5101376',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-22T16:20:00',
    endTime: '2018-12-22T16:30:00'
  },
  {
    id: '5072068',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-24T13:30:00',
    endTime: '2018-12-24T13:40:00'
  },
  {
    id: '5072069',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-24T13:40:00',
    endTime: '2018-12-24T13:50:00'
  },
  {
    id: '5072070',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-24T13:50:00',
    endTime: '2018-12-24T14:00:00'
  },
  {
    id: '5072072',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-24T14:00:00',
    endTime: '2018-12-24T14:10:00'
  },
  {
    id: '5072073',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-24T14:10:00',
    endTime: '2018-12-24T14:20:00'
  },
  {
    id: '5072074',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-24T14:20:00',
    endTime: '2018-12-24T14:30:00'
  },
  {
    id: '5072076',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-24T14:30:00',
    endTime: '2018-12-24T14:40:00'
  },
  {
    id: '5072077',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-24T14:40:00',
    endTime: '2018-12-24T14:50:00'
  },
  {
    id: '5072078',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-24T14:50:00',
    endTime: '2018-12-24T15:00:00'
  },
  {
    id: '5072079',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-24T15:00:00',
    endTime: '2018-12-24T15:10:00'
  },
  {
    id: '5072080',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-24T15:10:00',
    endTime: '2018-12-24T15:20:00'
  },
  {
    id: '5072081',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-24T15:20:00',
    endTime: '2018-12-24T15:30:00'
  },
  {
    id: '5072083',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-24T15:30:00',
    endTime: '2018-12-24T15:40:00'
  },
  {
    id: '5072084',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-24T15:40:00',
    endTime: '2018-12-24T15:50:00'
  },
  {
    id: '5072085',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-24T15:50:00',
    endTime: '2018-12-24T16:00:00'
  },
  {
    id: '5072086',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-24T16:00:00',
    endTime: '2018-12-24T16:10:00'
  },
  {
    id: '5072087',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-24T16:10:00',
    endTime: '2018-12-24T16:20:00'
  },
  {
    id: '5104746',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-25T08:00:00',
    endTime: '2018-12-25T08:10:00'
  },
  {
    id: '5101382',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-25T08:00:00',
    endTime: '2018-12-25T08:10:00'
  },
  {
    id: '5101383',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-25T08:10:00',
    endTime: '2018-12-25T08:20:00'
  },
  {
    id: '5101384',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-25T08:20:00',
    endTime: '2018-12-25T08:30:00'
  },
  {
    id: '5101385',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-25T08:30:00',
    endTime: '2018-12-25T08:40:00'
  },
  {
    id: '5101386',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-25T08:40:00',
    endTime: '2018-12-25T08:50:00'
  },
  {
    id: '5101387',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-25T08:50:00',
    endTime: '2018-12-25T09:00:00'
  },
  {
    id: '5101388',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-25T09:00:00',
    endTime: '2018-12-25T09:10:00'
  },
  {
    id: '5101389',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-25T09:10:00',
    endTime: '2018-12-25T09:20:00'
  },
  {
    id: '5101390',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-25T09:20:00',
    endTime: '2018-12-25T09:30:00'
  },
  {
    id: '5101391',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-25T09:30:00',
    endTime: '2018-12-25T09:40:00'
  },
  {
    id: '5101392',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-25T09:40:00',
    endTime: '2018-12-25T09:50:00'
  },
  {
    id: '5104747',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-25T08:10:00',
    endTime: '2018-12-25T08:20:00'
  },
  {
    id: '5104748',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-25T08:20:00',
    endTime: '2018-12-25T08:30:00'
  },
  {
    id: '5104749',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-25T08:30:00',
    endTime: '2018-12-25T08:40:00'
  },
  {
    id: '5104750',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-25T08:40:00',
    endTime: '2018-12-25T08:50:00'
  },
  {
    id: '5104751',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-25T08:50:00',
    endTime: '2018-12-25T09:00:00'
  },
  {
    id: '5104752',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-25T09:00:00',
    endTime: '2018-12-25T09:10:00'
  },
  {
    id: '5104753',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-25T09:10:00',
    endTime: '2018-12-25T09:20:00'
  },
  {
    id: '5104754',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-25T09:20:00',
    endTime: '2018-12-25T09:30:00'
  },
  {
    id: '5104755',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-25T09:30:00',
    endTime: '2018-12-25T09:40:00'
  },
  {
    id: '5104756',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-25T09:40:00',
    endTime: '2018-12-25T09:50:00'
  },
  {
    id: '5104759',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-25T10:00:00',
    endTime: '2018-12-25T10:10:00'
  },
  {
    id: '5104760',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-25T10:10:00',
    endTime: '2018-12-25T10:20:00'
  },
  {
    id: '5104761',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-25T10:20:00',
    endTime: '2018-12-25T10:30:00'
  },
  {
    id: '5104762',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-25T10:30:00',
    endTime: '2018-12-25T10:40:00'
  },
  {
    id: '5104763',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-25T10:40:00',
    endTime: '2018-12-25T10:50:00'
  },
  {
    id: '5104764',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-25T10:50:00',
    endTime: '2018-12-25T11:00:00'
  },
  {
    id: '5104765',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-25T11:00:00',
    endTime: '2018-12-25T11:10:00'
  },
  {
    id: '5104766',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-25T11:10:00',
    endTime: '2018-12-25T11:20:00'
  },
  {
    id: '5104767',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-25T11:20:00',
    endTime: '2018-12-25T11:30:00'
  },
  {
    id: '5104768',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-25T11:30:00',
    endTime: '2018-12-25T11:40:00'
  },
  {
    id: '5101406',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-25T12:30:00',
    endTime: '2018-12-25T12:40:00'
  },
  {
    id: '5101407',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-25T12:40:00',
    endTime: '2018-12-25T12:50:00'
  },
  {
    id: '5101408',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-25T12:50:00',
    endTime: '2018-12-25T13:00:00'
  },
  {
    id: '5101409',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-25T13:00:00',
    endTime: '2018-12-25T13:10:00'
  },
  {
    id: '5101410',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-25T13:10:00',
    endTime: '2018-12-25T13:20:00'
  },
  {
    id: '5101411',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-25T13:20:00',
    endTime: '2018-12-25T13:30:00'
  },
  {
    id: '5101412',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-25T13:30:00',
    endTime: '2018-12-25T13:40:00'
  },
  {
    id: '5101413',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-25T13:40:00',
    endTime: '2018-12-25T13:50:00'
  },
  {
    id: '5101414',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-25T13:50:00',
    endTime: '2018-12-25T14:00:00'
  },
  {
    id: '5101415',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-25T14:00:00',
    endTime: '2018-12-25T14:10:00'
  },
  {
    id: '5072142',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T08:00:00',
    endTime: '2018-12-26T08:10:00'
  },
  {
    id: '5072143',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T08:10:00',
    endTime: '2018-12-26T08:20:00'
  },
  {
    id: '5072144',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T08:20:00',
    endTime: '2018-12-26T08:30:00'
  },
  {
    id: '5072145',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T08:30:00',
    endTime: '2018-12-26T08:40:00'
  },
  {
    id: '5072146',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T08:40:00',
    endTime: '2018-12-26T08:50:00'
  },
  {
    id: '5072147',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T08:50:00',
    endTime: '2018-12-26T09:00:00'
  },
  {
    id: '5072148',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T09:00:00',
    endTime: '2018-12-26T09:10:00'
  },
  {
    id: '5072149',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T09:10:00',
    endTime: '2018-12-26T09:20:00'
  },
  {
    id: '5072150',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T09:20:00',
    endTime: '2018-12-26T09:30:00'
  },
  {
    id: '5072151',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T09:30:00',
    endTime: '2018-12-26T09:40:00'
  },
  {
    id: '5072164',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T13:30:00',
    endTime: '2018-12-26T13:40:00'
  },
  {
    id: '5072165',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T13:40:00',
    endTime: '2018-12-26T13:50:00'
  },
  {
    id: '5072166',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T13:50:00',
    endTime: '2018-12-26T14:00:00'
  },
  {
    id: '5072169',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T14:00:00',
    endTime: '2018-12-26T14:10:00'
  },
  {
    id: '5072170',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T14:10:00',
    endTime: '2018-12-26T14:20:00'
  },
  {
    id: '5072171',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T14:20:00',
    endTime: '2018-12-26T14:30:00'
  },
  {
    id: '5072174',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T14:30:00',
    endTime: '2018-12-26T14:40:00'
  },
  {
    id: '5072175',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T14:40:00',
    endTime: '2018-12-26T14:50:00'
  },
  {
    id: '5072176',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T14:50:00',
    endTime: '2018-12-26T15:00:00'
  },
  {
    id: '5072179',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T15:00:00',
    endTime: '2018-12-26T15:10:00'
  },
  {
    id: '5072180',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T15:10:00',
    endTime: '2018-12-26T15:20:00'
  },
  {
    id: '5072181',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T15:20:00',
    endTime: '2018-12-26T15:30:00'
  },
  {
    id: '5072184',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T15:30:00',
    endTime: '2018-12-26T15:40:00'
  },
  {
    id: '5072185',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T15:40:00',
    endTime: '2018-12-26T15:50:00'
  },
  {
    id: '5072186',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T15:50:00',
    endTime: '2018-12-26T16:00:00'
  },
  {
    id: '5072189',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T16:00:00',
    endTime: '2018-12-26T16:10:00'
  },
  {
    id: '5072190',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-26T16:10:00',
    endTime: '2018-12-26T16:20:00'
  },
  {
    id: '5104771',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T08:00:00',
    endTime: '2018-12-27T08:10:00'
  },
  {
    id: '5104772',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T08:10:00',
    endTime: '2018-12-27T08:20:00'
  },
  {
    id: '5104773',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T08:20:00',
    endTime: '2018-12-27T08:30:00'
  },
  {
    id: '5104775',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T08:30:00',
    endTime: '2018-12-27T08:40:00'
  },
  {
    id: '5104776',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T08:40:00',
    endTime: '2018-12-27T08:50:00'
  },
  {
    id: '5104777',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T08:50:00',
    endTime: '2018-12-27T09:00:00'
  },
  {
    id: '5104779',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T09:00:00',
    endTime: '2018-12-27T09:10:00'
  },
  {
    id: '5104780',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T09:10:00',
    endTime: '2018-12-27T09:20:00'
  },
  {
    id: '5104781',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T09:20:00',
    endTime: '2018-12-27T09:30:00'
  },
  {
    id: '5104783',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T09:30:00',
    endTime: '2018-12-27T09:40:00'
  },
  {
    id: '5104784',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T09:40:00',
    endTime: '2018-12-27T09:50:00'
  },
  {
    id: '5104785',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T09:50:00',
    endTime: '2018-12-27T10:00:00'
  },
  {
    id: '5104787',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T10:00:00',
    endTime: '2018-12-27T10:10:00'
  },
  {
    id: '5104788',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T10:10:00',
    endTime: '2018-12-27T10:20:00'
  },
  {
    id: '5104789',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T10:20:00',
    endTime: '2018-12-27T10:30:00'
  },
  {
    id: '5104791',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T10:30:00',
    endTime: '2018-12-27T10:40:00'
  },
  {
    id: '5104792',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T10:40:00',
    endTime: '2018-12-27T10:50:00'
  },
  {
    id: '5104793',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T10:50:00',
    endTime: '2018-12-27T11:00:00'
  },
  {
    id: '5104795',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T11:00:00',
    endTime: '2018-12-27T11:10:00'
  },
  {
    id: '5104800',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T13:00:00',
    endTime: '2018-12-27T13:10:00'
  },
  {
    id: '5104801',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T13:10:00',
    endTime: '2018-12-27T13:20:00'
  },
  {
    id: '5104802',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T13:20:00',
    endTime: '2018-12-27T13:30:00'
  },
  {
    id: '5104804',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T13:30:00',
    endTime: '2018-12-27T13:40:00'
  },
  {
    id: '5104805',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T13:40:00',
    endTime: '2018-12-27T13:50:00'
  },
  {
    id: '5104806',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T13:50:00',
    endTime: '2018-12-27T14:00:00'
  },
  {
    id: '5072198',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-27T13:40:00',
    endTime: '2018-12-27T13:50:00'
  },
  {
    id: '5072199',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-27T13:50:00',
    endTime: '2018-12-27T14:00:00'
  },
  {
    id: '5072201',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-27T14:00:00',
    endTime: '2018-12-27T14:10:00'
  },
  {
    id: '5104808',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T14:00:00',
    endTime: '2018-12-27T14:10:00'
  },
  {
    id: '5104809',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T14:10:00',
    endTime: '2018-12-27T14:20:00'
  },
  {
    id: '5104810',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T14:20:00',
    endTime: '2018-12-27T14:30:00'
  },
  {
    id: '5072202',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-27T14:10:00',
    endTime: '2018-12-27T14:20:00'
  },
  {
    id: '5072203',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-27T14:20:00',
    endTime: '2018-12-27T14:30:00'
  },
  {
    id: '5072206',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-27T14:30:00',
    endTime: '2018-12-27T14:40:00'
  },
  {
    id: '5072207',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-27T14:40:00',
    endTime: '2018-12-27T14:50:00'
  },
  {
    id: '5104812',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T14:30:00',
    endTime: '2018-12-27T14:40:00'
  },
  {
    id: '5104813',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T14:40:00',
    endTime: '2018-12-27T14:50:00'
  },
  {
    id: '5104814',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T14:50:00',
    endTime: '2018-12-27T15:00:00'
  },
  {
    id: '5072208',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-27T14:50:00',
    endTime: '2018-12-27T15:00:00'
  },
  {
    id: '5072210',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-27T15:00:00',
    endTime: '2018-12-27T15:10:00'
  },
  {
    id: '5104816',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T15:00:00',
    endTime: '2018-12-27T15:10:00'
  },
  {
    id: '5104817',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T15:10:00',
    endTime: '2018-12-27T15:20:00'
  },
  {
    id: '5104818',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T15:20:00',
    endTime: '2018-12-27T15:30:00'
  },
  {
    id: '5072211',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-27T15:10:00',
    endTime: '2018-12-27T15:20:00'
  },
  {
    id: '5072212',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-27T15:20:00',
    endTime: '2018-12-27T15:30:00'
  },
  {
    id: '5072215',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-27T15:30:00',
    endTime: '2018-12-27T15:40:00'
  },
  {
    id: '5072216',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-27T15:40:00',
    endTime: '2018-12-27T15:50:00'
  },
  {
    id: '5104820',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T15:30:00',
    endTime: '2018-12-27T15:40:00'
  },
  {
    id: '5104821',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T15:40:00',
    endTime: '2018-12-27T15:50:00'
  },
  {
    id: '5104822',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T15:50:00',
    endTime: '2018-12-27T16:00:00'
  },
  {
    id: '5104823',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-27T16:00:00',
    endTime: '2018-12-27T16:10:00'
  },
  {
    id: '5072217',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-27T15:50:00',
    endTime: '2018-12-27T16:00:00'
  },
  {
    id: '5072219',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-27T16:00:00',
    endTime: '2018-12-27T16:10:00'
  },
  {
    id: '5072220',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-27T16:10:00',
    endTime: '2018-12-27T16:20:00'
  },
  {
    id: '5072221',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-27T16:20:00',
    endTime: '2018-12-27T16:30:00'
  },
  {
    id: '5072227',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-28T13:40:00',
    endTime: '2018-12-28T13:50:00'
  },
  {
    id: '5072228',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-28T13:50:00',
    endTime: '2018-12-28T14:00:00'
  },
  {
    id: '5072230',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-28T14:00:00',
    endTime: '2018-12-28T14:10:00'
  },
  {
    id: '5104846',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-28T14:00:00',
    endTime: '2018-12-28T14:10:00'
  },
  {
    id: '5104847',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-28T14:10:00',
    endTime: '2018-12-28T14:20:00'
  },
  {
    id: '5104848',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-28T14:20:00',
    endTime: '2018-12-28T14:30:00'
  },
  {
    id: '5104849',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-28T14:30:00',
    endTime: '2018-12-28T14:40:00'
  },
  {
    id: '5104850',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-28T14:40:00',
    endTime: '2018-12-28T14:50:00'
  },
  {
    id: '5104851',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-28T14:50:00',
    endTime: '2018-12-28T15:00:00'
  },
  {
    id: '5104852',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-28T15:00:00',
    endTime: '2018-12-28T15:10:00'
  },
  {
    id: '5104853',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-28T15:10:00',
    endTime: '2018-12-28T15:20:00'
  },
  {
    id: '5104854',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-28T15:20:00',
    endTime: '2018-12-28T15:30:00'
  },
  {
    id: '5104855',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-28T15:30:00',
    endTime: '2018-12-28T15:40:00'
  },
  {
    id: '5072231',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-28T14:10:00',
    endTime: '2018-12-28T14:20:00'
  },
  {
    id: '5072232',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-28T14:20:00',
    endTime: '2018-12-28T14:30:00'
  },
  {
    id: '5072235',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-28T14:30:00',
    endTime: '2018-12-28T14:40:00'
  },
  {
    id: '5072236',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-28T14:40:00',
    endTime: '2018-12-28T14:50:00'
  },
  {
    id: '5072237',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-28T14:50:00',
    endTime: '2018-12-28T15:00:00'
  },
  {
    id: '5072239',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-28T15:00:00',
    endTime: '2018-12-28T15:10:00'
  },
  {
    id: '5072240',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-28T15:10:00',
    endTime: '2018-12-28T15:20:00'
  },
  {
    id: '5072241',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-28T15:20:00',
    endTime: '2018-12-28T15:30:00'
  },
  {
    id: '5072244',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-28T15:30:00',
    endTime: '2018-12-28T15:40:00'
  },
  {
    id: '5072245',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-28T15:40:00',
    endTime: '2018-12-28T15:50:00'
  },
  {
    id: '5072246',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-28T15:50:00',
    endTime: '2018-12-28T16:00:00'
  },
  {
    id: '5072248',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-28T16:00:00',
    endTime: '2018-12-28T16:10:00'
  },
  {
    id: '5072249',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-28T16:10:00',
    endTime: '2018-12-28T16:20:00'
  },
  {
    id: '5072250',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-28T16:20:00',
    endTime: '2018-12-28T16:30:00'
  },
  {
    id: '5105185',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-29T13:40:00',
    endTime: '2018-12-29T13:50:00'
  },
  {
    id: '5105186',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-29T13:50:00',
    endTime: '2018-12-29T14:00:00'
  },
  {
    id: '5105188',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-29T14:00:00',
    endTime: '2018-12-29T14:10:00'
  },
  {
    id: '5105189',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-29T14:10:00',
    endTime: '2018-12-29T14:20:00'
  },
  {
    id: '5105190',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-29T14:20:00',
    endTime: '2018-12-29T14:30:00'
  },
  {
    id: '5105193',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-29T14:30:00',
    endTime: '2018-12-29T14:40:00'
  },
  {
    id: '5105194',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-29T14:40:00',
    endTime: '2018-12-29T14:50:00'
  },
  {
    id: '5105195',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-29T14:50:00',
    endTime: '2018-12-29T15:00:00'
  },
  {
    id: '5105197',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-29T15:00:00',
    endTime: '2018-12-29T15:10:00'
  },
  {
    id: '5105198',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-29T15:10:00',
    endTime: '2018-12-29T15:20:00'
  },
  {
    id: '5105199',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-29T15:20:00',
    endTime: '2018-12-29T15:30:00'
  },
  {
    id: '5105202',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-29T15:30:00',
    endTime: '2018-12-29T15:40:00'
  },
  {
    id: '5105203',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-29T15:40:00',
    endTime: '2018-12-29T15:50:00'
  },
  {
    id: '5105204',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-29T15:50:00',
    endTime: '2018-12-29T16:00:00'
  },
  {
    id: '5105206',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-29T16:00:00',
    endTime: '2018-12-29T16:10:00'
  },
  {
    id: '5105207',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-29T16:10:00',
    endTime: '2018-12-29T16:20:00'
  },
  {
    id: '5105208',
    campus: {
      id: 'a7689ff0-ffaf-47ce-8dd9-40145b70113d',
      name: 'Campus Deurne',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-29T16:20:00',
    endTime: '2018-12-29T16:30:00'
  },
  {
    id: '5104864',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-31T08:40:00',
    endTime: '2018-12-31T08:50:00'
  },
  {
    id: '5104865',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-31T08:50:00',
    endTime: '2018-12-31T09:00:00'
  },
  {
    id: '5104866',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-31T09:00:00',
    endTime: '2018-12-31T09:10:00'
  },
  {
    id: '5104867',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-31T09:10:00',
    endTime: '2018-12-31T09:20:00'
  },
  {
    id: '5104868',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-31T09:20:00',
    endTime: '2018-12-31T09:30:00'
  },
  {
    id: '5104869',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-31T09:30:00',
    endTime: '2018-12-31T09:40:00'
  },
  {
    id: '5104870',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-31T09:40:00',
    endTime: '2018-12-31T09:50:00'
  },
  {
    id: '5104871',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-31T09:50:00',
    endTime: '2018-12-31T10:00:00'
  },
  {
    id: '5104872',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-31T10:00:00',
    endTime: '2018-12-31T10:10:00'
  },
  {
    id: '5104873',
    campus: {
      id: '8b54dee0-4484-4f04-9dc6-ac4384660fff',
      name: 'Private Campus Kielse Vest',
      isHigherFees: true
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-31T10:10:00',
    endTime: '2018-12-31T10:20:00'
  },
  {
    id: '5104883',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-31T13:00:00',
    endTime: '2018-12-31T13:10:00'
  },
  {
    id: '5104884',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-31T13:10:00',
    endTime: '2018-12-31T13:20:00'
  },
  {
    id: '5104885',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-31T13:20:00',
    endTime: '2018-12-31T13:30:00'
  },
  {
    id: '5104886',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-31T13:30:00',
    endTime: '2018-12-31T13:40:00'
  },
  {
    id: '5104887',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-31T13:40:00',
    endTime: '2018-12-31T13:50:00'
  },
  {
    id: '5104888',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-31T13:50:00',
    endTime: '2018-12-31T14:00:00'
  },
  {
    id: '5104889',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-31T14:00:00',
    endTime: '2018-12-31T14:10:00'
  },
  {
    id: '5104890',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-31T14:10:00',
    endTime: '2018-12-31T14:20:00'
  },
  {
    id: '5104891',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-31T14:20:00',
    endTime: '2018-12-31T14:30:00'
  },
  {
    id: '5104892',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-31T14:30:00',
    endTime: '2018-12-31T14:40:00'
  },
  {
    id: '5104893',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'ddda7b4d-b30c-4d6b-84be-63676935085b',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/van-riet-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elbow, wrist and hand'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Roger Van Riet',
          specialties: 'Elleboog, pols en hand'
        }
      ]
    },
    startTime: '2018-12-31T14:40:00',
    endTime: '2018-12-31T14:50:00'
  },
  {
    id: '5072258',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-31T13:30:00',
    endTime: '2018-12-31T13:40:00'
  },
  {
    id: '5072259',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-31T13:40:00',
    endTime: '2018-12-31T13:50:00'
  },
  {
    id: '5072260',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-31T13:50:00',
    endTime: '2018-12-31T14:00:00'
  },
  {
    id: '5072262',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-31T14:00:00',
    endTime: '2018-12-31T14:10:00'
  },
  {
    id: '5072263',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-31T14:10:00',
    endTime: '2018-12-31T14:20:00'
  },
  {
    id: '5072264',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-31T14:20:00',
    endTime: '2018-12-31T14:30:00'
  },
  {
    id: '5072266',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-31T14:30:00',
    endTime: '2018-12-31T14:40:00'
  },
  {
    id: '5072267',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-31T14:40:00',
    endTime: '2018-12-31T14:50:00'
  },
  {
    id: '5072268',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-31T14:50:00',
    endTime: '2018-12-31T15:00:00'
  },
  {
    id: '5072269',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-31T15:00:00',
    endTime: '2018-12-31T15:10:00'
  },
  {
    id: '5072270',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-31T15:10:00',
    endTime: '2018-12-31T15:20:00'
  },
  {
    id: '5072271',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-31T15:20:00',
    endTime: '2018-12-31T15:30:00'
  },
  {
    id: '5072273',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-31T15:30:00',
    endTime: '2018-12-31T15:40:00'
  },
  {
    id: '5072274',
    campus: {
      id: '323e8c28-9bdf-4e02-8354-6469debc17d2',
      name: 'Campus Antwerpen',
      isHigherFees: false
    },
    practitioner: {
      id: 'd17b0987-9445-4ba9-bcc8-59ad4876e6c3',
      photo: 'http://orthoca.be/wp-content/uploads/2014/07/verdonk-peter-540x580-540x580.png',
      localizations: [
        {
          lang: 'en',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knee and sports injuries'
        },
        {
          lang: 'nl',
          name: 'Prof. Dr. Peter Verdonk',
          specialties: 'Knie en sportletsels'
        }
      ]
    },
    startTime: '2018-12-31T15:40:00',
    endTime: '2018-12-31T15:50:00'
  }
];
